module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img65.5521f97e.jpg";